// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"727":"aec6c4e5913e882985c3","798":"018a380d4bc55ef225df","890":"7362852f1b27f3c51d87"}[chunkId] + ".min.js";
};